/**
 * D1 no-orphans for FAQ text (questions and answers).
 *
 * A short last word (fewer than 7 letters/digits) must never sit alone on the
 * last line of a block of FAQ text. The whitespace between the last two words of
 * each block is replaced with a no-break space (U+00A0). Nothing else is changed:
 * markup is never rewritten and single-word blocks are skipped.
 *
 * Runs on DOMContentLoaded and on shopify:section:load (theme editor re-renders).
 * Loaded with defer from sections/d1-faq.liquid, so every template that renders
 * the D1 FAQ section gets it.
 */
(function () {
  'use strict';

  if (window.D1NoOrphans) {
    return;
  }

  var ROOT_SELECTOR = '.d1-faq';
  var BLOCK_SELECTOR = [
    '.d1-faq__question',
    '.d1-faq__answer',
    'summary',
    'p',
    'li',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'dt', 'dd', 'blockquote', 'figcaption'
  ].join(',');
  var MIN_LETTERS = 7;
  var NBSP = '\u00A0';
  var WHITESPACE = /\s/;
  var COUNTED = (function () {
    try {
      return new RegExp('[\\p{L}\\p{N}]', 'u');
    } catch (e) {
      return /[A-Za-z0-9\u00C0-\u024F]/;
    }
  })();
  var BOUNDARY = { boundary: true };
  // Elements that start or end a line: a word never continues across them.
  var BOUNDARY_TAGS = {
    BR: 1, P: 1, LI: 1, UL: 1, OL: 1, DL: 1, DT: 1, DD: 1, DIV: 1, DETAILS: 1,
    SUMMARY: 1, H1: 1, H2: 1, H3: 1, H4: 1, H5: 1, H6: 1, BLOCKQUOTE: 1,
    FIGCAPTION: 1, SECTION: 1, ARTICLE: 1, HEADER: 1, FOOTER: 1, TABLE: 1,
    TR: 1, TD: 1, TH: 1, PRE: 1, HR: 1
  };
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, TEMPLATE: 1, NOSCRIPT: 1 };

  var stats = { runs: 0, roots: 0, blocks: 0, joined: 0, alreadyJoined: 0, longEnough: 0, singleWord: 0 };

  // Characters of a block in reading order, each tied to its text node.
  function flatten(el, out) {
    for (var child = el.firstChild; child; child = child.nextSibling) {
      if (child.nodeType === 3) {
        var value = child.nodeValue;
        for (var i = 0; i < value.length; i++) {
          out.push({ ch: value.charAt(i), node: child, index: i });
        }
      } else if (child.nodeType === 1 && !SKIP_TAGS[child.nodeName]) {
        var isBoundary = !!BOUNDARY_TAGS[child.nodeName];
        if (isBoundary) { out.push(BOUNDARY); }
        flatten(child, out);
        if (isBoundary) { out.push(BOUNDARY); }
      }
    }
    return out;
  }

  function isSpace(item) {
    return !item.boundary && WHITESPACE.test(item.ch);
  }

  // Returns: 'joined' | 'already' | 'long' | 'single' | 'empty'
  function processBlock(block) {
    var items = flatten(block, []);

    // 1. Last visible character of the block.
    var end = items.length - 1;
    while (end >= 0 && (items[end].boundary || WHITESPACE.test(items[end].ch))) {
      end--;
    }
    if (end < 0) { return 'empty'; }

    // 2. Walk back over the last word.
    var start = end;
    while (start > 0 && !items[start - 1].boundary && !WHITESPACE.test(items[start - 1].ch)) {
      start--;
    }
    // Nothing before the last word inside this block: one word, nothing to join.
    if (start === 0 || items[start - 1].boundary) { return 'single'; }

    // 3. Letters/digits in the last word.
    var letters = 0;
    for (var k = start; k <= end; k++) {
      if (COUNTED.test(items[k].ch)) { letters++; }
    }
    if (letters >= MIN_LETTERS) { return 'long'; }

    // 4. Whitespace run between the previous word and the last word.
    var runEnd = start - 1;
    var runStart = runEnd;
    while (runStart > 0 && isSpace(items[runStart - 1])) { runStart--; }

    if (runStart === runEnd && items[runEnd].ch === NBSP) { return 'already'; }

    // 5. Replace the run with one no-break space, editing text nodes in place.
    var edits = new Map();
    for (var r = runStart; r <= runEnd; r++) {
      var item = items[r];
      if (!edits.has(item.node)) { edits.set(item.node, {}); }
      edits.get(item.node)[item.index] = (r === runEnd) ? NBSP : '';
    }
    edits.forEach(function (changes, node) {
      var value = node.nodeValue;
      var out = '';
      for (var c = 0; c < value.length; c++) {
        out += (c in changes) ? changes[c] : value.charAt(c);
      }
      if (out !== value) { node.nodeValue = out; }
    });
    return 'joined';
  }

  function run(scope) {
    var base = scope || document;
    var roots = [];
    if (base.nodeType === 1 && base.matches(ROOT_SELECTOR)) { roots.push(base); }
    base.querySelectorAll(ROOT_SELECTOR).forEach(function (el) { roots.push(el); });

    stats.runs++;
    roots.forEach(function (rootEl) {
      var counts = { blocks: 0, joined: 0, already: 0, long: 0, single: 0, empty: 0 };
      rootEl.querySelectorAll(BLOCK_SELECTOR).forEach(function (block) {
        var status = processBlock(block);
        counts.blocks++;
        counts[status]++;
      });
      stats.roots++;
      stats.blocks += counts.blocks;
      stats.joined += counts.joined;
      stats.alreadyJoined += counts.already;
      stats.longEnough += counts.long;
      stats.singleWord += counts.single;
      rootEl.setAttribute('data-d1-no-orphans',
        'blocks=' + counts.blocks + ' joined=' + counts.joined + ' already=' + counts.already +
        ' long=' + counts.long + ' single=' + counts.single);
    });
    return stats;
  }

  window.D1NoOrphans = { version: '1.0.0', minLetters: MIN_LETTERS, stats: stats, run: run };

  function init() {
    run(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    run(event.target);
  });
})();
